var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34995 0.789062C1.57635 0.789062 0.949219 1.41619 0.949219 2.18979V18.5983C0.949219 19.3719 1.57635 19.9991 2.34995 19.9991C3.12355 19.9991 3.75068 19.3719 3.75068 18.5983V2.18979C3.75068 1.41619 3.12355 0.789062 2.34995 0.789062ZM13.3395 18.9463C12.7619 19.5454 11.8025 19.5454 11.225 18.9463L4.16218 11.6202C3.86703 11.314 3.73072 10.9117 3.75328 10.5167C3.733 10.1243 3.86945 9.72536 4.16262 9.42126L11.2254 2.09517C11.8029 1.49609 12.7624 1.49609 13.3399 2.09517C13.8883 2.66403 13.8883 3.56484 13.3399 4.1337L7.18226 10.5209L13.3395 16.9077C13.8879 17.4766 13.8879 18.3774 13.3395 18.9463Z",
    fill: "#575757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowPage);
export default __webpack_public_path__ + "static/media/icon_arrow-page.99031770cd53ec3a288400a2be24f5e9.svg";
export { ForwardRef as ReactComponent };